import {Injectable, SecurityContext, TemplateRef} from '@angular/core';
import {Toast, ToastModel, ToastUtility} from "@syncfusion/ej2-angular-notifications";
import {SanitizeService} from "../sanitize/sanitize.service";

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private DEFAULT_TIMEOUT = 3000;

  constructor(private sanitize: SanitizeService) {
    (window as any).ToastAPI = this;
  }

  showInfo(toast: string | ToastModel, timeout: number = this.DEFAULT_TIMEOUT) {
    ToastUtility.show(this.makeModel(toast, 'Information', timeout), 'Information', timeout);
  }

  showSuccess(toast: string | ToastModel, timeout: number = this.DEFAULT_TIMEOUT) {
    ToastUtility.show(this.makeModel(toast, 'Success', timeout), 'Success', timeout);
  }

  showWarning(toast: string | ToastModel, timeout: number = this.DEFAULT_TIMEOUT) {
    ToastUtility.show(this.makeModel(toast, 'Warning', timeout), 'Warning', timeout);
  }

  showDanger(toast: string | ToastModel, timeout: number = this.DEFAULT_TIMEOUT) {
    ToastUtility.show(this.makeModel(toast, 'Error', timeout), 'Error', timeout);
  }

  showError(toast: string | ToastModel, timeout: number = this.DEFAULT_TIMEOUT) {
    ToastUtility.show(this.makeModel(toast, 'Error', timeout), 'Error', timeout);
  }

  private makeModel(toast: string | ToastModel, type: string, timeout: number): ToastModel {

    if (typeof toast === "string") {
      const defaultModel: ToastModel = {
        position: {
          X: 'Right',
          Y: 'Bottom'
        },
        animation: {
          show: {
            effect: 'SlideRightIn'
          },
          hide: {
            effect: 'SlideRightOut'
          },
        }
      };

      let cssClass = 'e-toast-success';
      let icon = 'e-toast-success-icon';
      switch (type) {
        case 'Information':
          cssClass = 'e-toast-info';
          icon = 'e-toast-info-icon';
          break;
        case 'Success':
          cssClass = 'e-toast-success';
          icon = 'e-toast-success-icon';
          break;
        case 'Warning':
          cssClass = 'e-toast-warning';
          icon = 'e-toast-warning-icon';
          break;
        case 'Error':
          cssClass = 'e-toast-danger';
          icon = 'e-toast-error-icon';
          break;
      }

      let extraModel: ToastModel = {
        content: this.sanitize.sanitize(SecurityContext.HTML, toast),
        timeOut: timeout,
        cssClass: cssClass,
        icon: icon,
      };

     return {...defaultModel, ...extraModel};
    } else {
      return toast;
    }
  }
}
